<template>
  <div :class="device" class="quantities-section-wrapper">
    <div :class="wrapperClass">
      <section class="desc">
        <h2 class="title">
          Join the learning economy
        </h2>
        <div class="description">
          Students and professionals of all levels can use Workera to measure
          their data-AI skills today and develop the necessary skills for
          tomorrow.<br />
          <div class="v-space" />
          Develop expertise in these disciplines:
        </div>
        <section class="test-sections">
          <div
            v-for="section in sections"
            :key="section"
            class="test-section description-3"
          >
            <!--nuxt-link to="/app/login/" class="backgorund-color" style="text-decoration:none;"> {{ section }}</nuxt-link-->
            <a class="blue-button-regular-1" href="/app/login/">{{
              section
            }}</a>
          </div>
          <div class="test-section description-3">
            <!--nuxt-link to="/app/login/" class="backgorund-color" style="text-decoration:none;"> {{ section }}</nuxt-link-->
            <a
              class="white-button-blue-border last-btn"
              href="/app/login/"
              >Discover My Career Track
              <font-awesome-icon icon="long-arrow-alt-right" />
            </a>
          </div>
        </section>
      </section>
    </div>
    <div id="steps"></div>
  </div>
</template>

<script>
// In your Vue.js component.
import { Hooper, Slide, Pagination as HooperPagination } from "hooper";
import "hooper/dist/hooper.css";

import "vueperslides/dist/vueperslides.css";

export default {
  components: {},
  data() {
    return {
      sections: [
        "Data Analyst",
        "Data Scientist",
        "Machine Learning Engineer",
        "Machine Learning Researcher",
        "Software engineer",
        "Software Engineer - Machine Learning",
        "Software Engineer - Deep Learning",
        "Deep Learning Engineer",
        "Deep Learning Researcher",
        "AI Literacy",
        "Data Literacy"
      ]
    };
  },
  computed: {
    wrapperClass() {
      switch (this.$mq) {
        case "desktop":
          return "wrapper desktop";
        case "tablet":
          return "wrapper tablet";
        default:
          return "wrapper mobile";
      }
    },
    device() {
      switch (this.$mq) {
        case "desktop":
          return "desktop";
        case "tablet":
          return "tablet";
        default:
          return "mobile";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
%wrapper {
  display: flex;
  flex-direction: column;
  padding: 4rem 1.4rem;

  /*.description-2 {
    max-width: 900px;
  }*/
}

.quantities-section-wrapper {
  @extend %wrapper;
  &.mobile {
    padding: 2rem 1.5rem;
  }
  .test-section {
    font-weight: 700;
    font-size: 16px;
    border-radius: 5px;
    display: block;
    margin-right: 0.2rem;
    margin-bottom: 0.2rem;
    color: #0062cc;

    a {
      padding: 1rem 1.2rem;
      min-width: max-content;
    }
  }
  .title {
    font-weight: 800;
    font-size: 36px;
    line-height: 36px;
    letter-spacing: -0.8px;
  }
  .description {
    font-weight: 600;
    font-size: 18px;
    line-height: 23.54px;
    letter-spacing: 0.03px;
  }

  .mobile {
    .title {
      font-weight: 800;
      font-size: 32px;
      line-height: 36px;
      letter-spacing: -0.8px;
    }
    .description {
      font-weight: 600;
      font-size: 18px;
      line-height: 20.93px;
      letter-spacing: 0.03px;
    }
    .test-section {
      a {
        min-width: 100px;
        margin: auto;
        margin-top: 0.5rem;
        padding: 0.6rem 0.8rem;
        height: 3.82rem;
        display: table-cell;
        vertical-align: middle;
      }
    }
  }
}

.test-sections {
  padding-top: 1rem;
  display: flex;
  flex-wrap: wrap;
}

.desc {
  margin-left: 1rem;
}

.last-btn {
  background: white !important;
  border: solid !important;
}

.blue-button-regular-1 {
  background: #e6f5fa;
  color: #0062cc;
  border: none;
  font-size: 16px;
  padding: 1rem 2rem;
}
.white-button-blue-border {
  font-size: 16px;
  padding: 1rem 2rem;
}
.v-space {
  height: 1rem;
}
</style>

<style lang="scss"></style>
